<template>
  <div :class="[wrapperClass]">
    <label :class="[labelClass]"
           for=""> {{ label }}<span v-if="validator && validator.$params.required">*</span> </label>
    <div :class="[{ 'has-error has-danger':validator && validator.$error },fileChooserWrapperClass]" >
      <vue-dropzone
        :id="id"
        :ref="id"
        :class="[{'file-dropping': fileDroping, 'dz-started': files.length > 0}, fileChooserClass]"
        :options="dropzoneOptions"
        class="upload-wrapper"
        use-custom-slot
        @vdropzone-reset="handleReset()"
        @vdropzone-max-files-reached="handleMaxFileReached()"
        @vdropzone-removed-file="(payload) => {handleRemovingFile(payload); $emit('removed-file', payload)}"
        @vdropzone-files-added="(payload) => {handleFileAddition(payload); $emit('files-added', payload)}"
        @vdropzone-drag-over="handleDragOver()"
        @vdropzone-drag-leave="handleDragLeave()"
        @vdropzone-drop="fileDroping = false"
        @vdropzone-mounted="checkForPreRender()"
        @vdropzone-complete="(file)=> {handleFileAddition(file); $emit('files-complated',file)}"
      >
        <div>
          <div class="subtitle"><span class="dz-icon"><i class="ti-cloud-up"/></span>{{ $t('fileUploadDragDrop') }}</div>
        </div>
      </vue-dropzone>
      <div class="help-block form-text form-control-feedback">
        <strong v-if="validator && validator.$error && !validator.required"> {{ label.toLowerCase() }}{{ $t('fileUploadIsRequired') }}  </strong>
        <template v-for="(error, index) in errors">
          <strong :key="index"> {{ error }} </strong>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { fileName } from '@/utils'

export default {
	name: 't-file-chooser',
	components: {
	},
	props: {
		label: {
			type: String,
			default: 'File Chooser'
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		fileChooserClass: {
			type: String,
			default: 'form-control'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		fileChooserWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		multiple: {
			type: Boolean,
			default: false
		},
		acceptedFiles: {
			type: String,
			default: '.png, .jpg, .jpeg'
		},
		value: {
			type: [File, FileList, Array, String, Object],
			default: () => {
				if (this.multiple) return []
				return null
			}
		},
		validator: {
			type: Object,
			default: null
		},
		errors: {
			type: Array,
			default: () => {
				return null
			}
		}
	},
	data () {
		return {
			files: [],
			dropzoneOptions: {
				url: this.$http.defaults.baseURL,
				thumbnailWidth: 150,
				thumbnailHeight: 150,
				maxFilesize: 5,
				addRemoveLinks: true,
				autoProcessQueue: false,
				previewTemplate: this.dropZoneCustomTemplate(),
				acceptedFiles: this.acceptedFiles,
				maxFiles: this.multiple ? null : 1
			},
			fileDroping: false
		}
	},
	computed: {
		id () {
			return Math.random().toString().replace('0.', '')
		}
	},
	methods: {
		tes (file) {
			this.$emit('files-complated', file)
		},
		dropZoneCustomTemplate () {
			return `<div class='dz-preview dz-file-preview'>
							<div class='dz-image'>
									<img data-dz-thumbnail />
							</div>
							<div class='dz-details'>
									<div class='dz-size'><span data-dz-size></span></div>
									<div class='dz-filename'><span data-dz-name></span></div>
							</div>
							<div class='dz-success-mark'><i class='fa fa-check'></i></div>
					</div>
			`
		},
		handleFileAddition (payload) {
			Array.from(payload).forEach((file) => this.files.push(file))
			if (this.multiple) return this.$emit('input', this.files)
			this.$emit('input', payload[payload.length - 1])
		},
		handleRemovingFile (payload) {
			this.files.splice(this.files.indexOf(payload), 1)
			if (this.multiple) return this.$emit('input', this.files)
			this.$emit('input', null)
		},
		handleMaxFileReached () {
			this.$refs[this.id].disable()
		},
		handleReset () {
			this.$refs[this.id].enable()
		},
		handleDragOver () {
			this.fileDroping = true
		},
		handleDragLeave () {
			this.fileDroping = false
		},
		async checkForPreRender () {
			if (Array.isArray(this.value)) {
				this.value.map((file) => {
					fetch(file)
						.then(res => res.blob())
						.then(blob => {
							this.manuallyAddFile(new File([blob], file.name), file)
						})
				})
				return
			}
			if (this.value) {
				console.log(12354)
				fetch(this.value)
					.then(res => res.blob())
					.then(blob => {
						this.manuallyAddFile(new File([blob], this.value.name || fileName(this.value)), this.value)
					})
			}
		},
		manuallyAddFile: function (file, fileUrl) {
			file.manuallyAdded = true
			this.$refs[this.id].dropzone.emit('addedfile', file)
			let containsImageFileType = false
			if (fileUrl.indexOf('.png') > -1 || fileUrl.indexOf('.jpg') > -1 || fileUrl.indexOf('.jpeg') > -1) containsImageFileType = true
			if (this.$refs[this.id].dropzone.options.createImageThumbnails && containsImageFileType && file.size <= this.$refs[this.id].dropzone.options.maxThumbnailFilesize * 1024 * 1024) {
				fileUrl && this.$refs[this.id].dropzone.emit('thumbnail', file, fileUrl)
				var thumbnails = file.previewElement.querySelectorAll('[data-dz-thumbnail]')
				for (var i = 0; i < thumbnails.length; i++) {
					thumbnails[i].style.width = this.$refs[this.id].dropzoneSettings.thumbnailWidth + 'px'
					thumbnails[i].style.height = this.$refs[this.id].dropzoneSettings.thumbnailHeight + 'px'
					thumbnails[i].style['object-fit'] = 'contain'
				}
			}
			this.$refs[this.id].dropzone.emit('complete', file)
			if (this.$refs[this.id].dropzone.options.maxFiles) this.$refs[this.id].dropzone.options.maxFiles--
			this.$refs[this.id].dropzone.files.push(file)
			this.handleFileAddition([file])
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/filechooser/index.vue